import { parse } from 'query-string';
import { normalizeObject } from 'component/helper/normalize-object';

export const getNormalizedQuery = () => {
    const qs = parse(location.search);

    return normalizeObject(qs);
};
